export const SET_TOKEN = 'SET_TOKEN'
export const SET_FIRSTTIME = 'SET_FIRSTTIME'
export const SET_CONFIRMED_PAYMENT = 'SET_CONFIRMED_PAYMENT'
export const SET_TAKEOUT_READY = 'SET_TAKEOUT_READY'
export const SET_LANG = 'SET_LANG'
export const SET_LANGUAGE_PREFERENCES = 'SET_LANGUAGE_PREFERENCES'
